import { String } from 'typescript-string-operations';
export class LayerEdge {
    constructor(source, target, crossingWeight, weight = 1) {
        this.Source = source;
        this.Target = target;
        this.CrossingWeight = crossingWeight;
        this.Weight = weight;
    }
    toString() {
        return String.format('{0}->{1}', this.Source, this.Target);
    }
}
//# sourceMappingURL=layerEdge.js.map